






























import { Component, Vue, Prop } from "vue-property-decorator";
import KYCAuthAction from "./KYCAuthAction.vue";
import { KYCShowsStatus } from "basis/utils/kyc";
import utils from "basis/utils";

@Component({
  components: {
    "kyc-auth-action": KYCAuthAction
  }
})
class KYCActions extends Vue {
  @Prop() profile;

  get meta() {
    const { kyc_status: status } = this.profile;
    const kycStatusMeta = utils.kyc.getKYCStatusMeta(status);
    const kycStatus = kycStatusMeta && kycStatusMeta.status;
    return {
      showAuthAction: kycStatus === KYCShowsStatus.NOTYET,
      showReAuthAction:
        kycStatus === KYCShowsStatus.PROCESSING ||
        kycStatus === KYCShowsStatus.REJECTED,
      showBackAction:
        kycStatus === KYCShowsStatus.PROCESSING ||
        kycStatus === KYCShowsStatus.APPROVED
    };
  }

  handleBack() {
    this.$router.back();
  }
}
export default KYCActions;
